module.exports = __webpack_public_path__ + "img/twitter.1d8a5136.svg";